export enum FunderRequestStatusEnum {
  None = 'None',
  Requested = 'Requested',
  Granted = 'Granted',
  Denied = 'Denied',
}
